import * as React from 'react';

import { goToAccountInfo, locationsUrl } from 'src/utils/navigation';
import './Notifications.scss';
import notificationIcon from 'src/assets/notificationIcon';
import location from 'src/assets/locationIcon';
import creditIcon from 'src/assets/creditIcon';
import webIcon from 'src/assets/webIcon';
import settingIcon from 'src/assets/settingIcon';
interface INotificationsState {
  floatingIsOpen: boolean;
  isNotificationAvailable: number;
  isNotificationAvailableCount: number;
  colorIndex:number;
}

interface INotificationsProps {
  isLoggedIn: boolean;
  userData: any;
  t: any;
  handleCloseAll: () => void;
}

export default class Notifications extends React.Component<
  INotificationsProps,
  INotificationsState
> {
  private flyMenuRef: any = null;
  private timer: ReturnType<typeof setTimeout> | undefined;
  private colors: string[] = ['red', 'rgb(227, 161, 36)'];
  private interval: ReturnType<typeof setInterval>;
  constructor(props: any) {
    super(props);    

    this.state = {
      floatingIsOpen: false,
      isNotificationAvailable: 0,
      isNotificationAvailableCount: 0,
      colorIndex: 0
    };
  }

  public componentDidUpdate(prevProps:any, prevState:any) {

    const { emailValid, mobileValid } = this.props.userData;

    const shouldOpenFloating =
    ((!emailValid && typeof emailValid !== 'undefined') ||
   (!mobileValid && typeof mobileValid !== 'undefined')) &&
    this.props.isLoggedIn &&
    window.location.hash === '' &&
    (localStorage.getItem("checkSpecialUser") === null || localStorage.getItem("checkSpecialUser") === 'undefined') &&
    (localStorage.getItem('closeNotification') === null || localStorage.getItem('closeNotification') ==='');

    if(shouldOpenFloating && !this.state.floatingIsOpen ) {
      this.setState({ floatingIsOpen: true });
   }
    // Compare old and new state
    if (!prevState.showNotification && this.state.floatingIsOpen && (localStorage.getItem("closeNotification") === null || localStorage.getItem("closeNotification") === '')) {
      this.timer = setTimeout(() => {
        this.closedNotifcation();
      }, 5000); // 5 seconds
    }
  }


  public componentDidMount() {
    this.interval = setInterval(() => {
      this.setState(prevState => ({
        colorIndex: (prevState.colorIndex + 1) % this.colors.length,
      }));
    }, 1000);
  }


  /* 
    openMenu
   */
  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };  

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      floatingIsOpen: false
    });
  };
  

  public closedNotifcation() {
    this.setState({ floatingIsOpen: false });   
    localStorage.setItem('closeNotification', 'yes'); 
  }
  
  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
    clearTimeout(this.timer);
    clearInterval(this.interval);
  }
  

  public render() {

    const { t, userData } = this.props;
    const backgroundColor = !userData.emailValid ? this.colors[this.state.colorIndex]:'';    
    const menuState = this.state.floatingIsOpen ? 'opened' : '';
    localStorage.setItem('checkSpecialUser', userData.specialUser);
    let notificationIncrement = 0;
      if (this.props.userData.emailValid === false && this.props.userData.mobileValid === false) {
        notificationIncrement = 1;
      } else if (this.props.userData.emailValid === false) {
        notificationIncrement = 1;
      } else if (this.props.userData.mobileValid === false) {
        notificationIncrement = 1;
      }
    return (     
      
      <div
        id="my-orders-menu"
        onMouseOut={this.closeMenu}
        onMouseOver={this.openMenu}
        onKeyDown={(event:any) => {
          if(event.keyCode === 13) {
            this.openMenu();
          } 
        }}
        className="my-notification-menu"
      >
        <div
          className="my-orders-menu--my-account"
          onClick={this.handleMenuState}
        > 
          <div className="my-orders-menu--info">
          {this.props.userData && notificationIncrement >0 && (
              <div className="rp-notification-count" style={{ backgroundColor,color: '#fff' }}>{notificationIncrement}</div>
            )}
            <img
              src={notificationIcon}
              alt="more icon"
              className="your-order-icon"
            />
            <div className="go-to-account" role="button" tabIndex={0}>
              <p className="rp-more-text" >{t('menu.yourNotificationsMenu')} </p>
            </div>
          </div>
        </div>
        <div
          className={`my-orders-menu--my-account--fly-menu ${menuState}`}
          ref={ref => (this.flyMenuRef = ref)}
        >
          <p className="menu-item-heading">{t('menu.yourNotifications')} 
            {(!this.props.userData.emailValid || !this.props.userData.mobileValid) && this.props.isLoggedIn && window.location.hash ==='' && (localStorage.getItem("checkSpecialUser") ==='undefined' || localStorage.getItem("checkSpecialUser")===null) && localStorage.getItem('closeNotification') === null && (
              <span className="menu-item-heading-close" onClick={(e) => {
                this.closedNotifcation();
              }} >X</span>
            )}
            </p>
          

          {/* <a className="menu-item menu-link">
            <img src={creditIcon} alt="icon" className="menu-item-icon" />
            <span />
          </a> */}

          {!userData.emailValid && !userData.mobileValid && this.props.isLoggedIn && (
            <a style={
              localStorage.getItem("checkSpecialUser") === 'undefined' ||
              localStorage.getItem("checkSpecialUser") === null
                ? { color: 'red',textDecoration: 'underline' }
                : undefined
             } 
              className="menu-item menu-link showNotification"
              onClick={(e) => {
                goToAccountInfo();
              }}
            >
              <img src={webIcon} alt="icon" className="menu-item-icon notification-icon" />
              {t('common.emailMobileVerifyNotify')}
            </a>
          )}

          {!userData.emailValid && userData.mobileValid && this.props.isLoggedIn && (
            <a  style={
              localStorage.getItem("checkSpecialUser") === 'undefined' ||
              localStorage.getItem("checkSpecialUser") === null
                ? { color: 'red',textDecoration: 'underline' }
                : undefined
             } 
              className="menu-item menu-link showNotification"
              onClick={(e) => {
                goToAccountInfo();
              }}
            >
              <img src={webIcon} alt="icon" className="menu-item-icon notification-icon" />
              {t('common.emailVerifyNotify')}
            </a>
          )}

          {userData.emailValid && !userData.mobileValid && this.props.isLoggedIn && (
            <a style={
              localStorage.getItem("checkSpecialUser") === 'undefined' ||
              localStorage.getItem("checkSpecialUser") === null
                ? {textDecoration: 'underline' }
                : undefined
             } 
              className="menu-item menu-link showNotification"
              onClick={(e) => {
                goToAccountInfo();
              }}
            >
              <img src={webIcon} alt="icon" className="menu-item-icon notification-icon" />
              {t('common.phoneVerifyNotify')}
            </a>
          )}



          {/* <a className="menu-item menu-link">
            <img
              src={settingIcon}
              alt="icon"
              className="menu-item-icon notification-icon"
            />
            <span />
          </a> */}
        </div>
      </div>
    );
  }
}
